import WebApi from "@/views/loyalty/shared/modules/web_api"

export class MqttDingtianEndpointService {
    constructor (store) {
        this.url = `${process.env.VUE_APP_MQTT_URL}api/dingtian/`
        this.webApi = new WebApi(store)
    }

    async getStatus (request) {
        return this.webApi.post(`${this.url}GetStatus`, request)
    }

    async sendMessage (request) {
        return this.webApi.post(`${this.url}SendMessages`, request)
    }

    async sendMessageFromCart (request) {
        return this.webApi.post(`${this.url}SendMessages`, request)
    }

    async sendMessageRepeat (request) {
        return this.webApi.post(`${this.url}SendMessagesRepeat`, request)
    }
}
